<script>
import { toBase64 } from '@shared/services/Utils';

export default {
  forms: [
    {
      name: {
        label: 'Titre',
        type: 'text',
        column: 'is-12',
        inputAttrs: {
          required: true,
          maxlength: 128,
          hasCounter: false,
        },
      },
      slug: {
        label: 'URL (pour le SEO)',
        type: 'text',
        column: 'is-12',
        hasAddonLeft: true,
        hasAddonRight: true,
        inputAttrs: {
          maxlength: 128,
          hasCounter: false,
          expanded: true,
        },
      },
      billing_address_enabled: {
        switchLabel: 'Demander l\'adresse de facturation lors des achats',
        type: 'switch',
        column: 'is-12',
      },
      picture: {
        label: 'Image',
        type: 'upload',
        inputAttrs: { accept: 'image/*' },
        column: 'is-6',
      },
    },
  ],
  created() {
    this.hydrate();
  },
  data() {
    return {
      isLoading: {
        0: false,
        1: false,
      },
      membership: {
        name: '',
        slug: '',
        feature_options: {
          billing_address: {
            enabled: false,
          },
        },
        picture: '',
      },
    };
  },
  computed: {
    currentMembership() {
      return this.$store.state.memberships.current;
    },
    authStore() {
      return this.$store.getters['auth/store'];
    },
    membershipIsDraft() {
      return this.currentMembership.status === 'DRAFT';
    },
    membershipURL() {
      const p = this.membershipIsDraft ? `?p=${this.$store.state.auth.previewToken}` : '';

      return `${this.$store.getters['auth/url']}/abonnements/${this.membership.slug}${p}`;
    },
  },

  methods: {
    hydrate() {
      Object.keys(this.membership)
        .forEach((key) => {
          if (key === 'feature_options') {
            const currentOptions = this.currentMembership[key] || {};
            const currentBilling = currentOptions.billing_address || {};
            this.membership[key] = {
              ...currentOptions,
              billing_address: {
                enabled: currentBilling.enabled || false,
              },
            };
          } else {
            this.membership[key] = this.currentMembership[key];
          }
        });
    },
    onViewDraft(event) {
      if (this.membershipIsDraft) {
        event.preventDefault();
        this.$buefy.dialog.confirm({
          title: 'Abonnement en brouillon !',
          message: `
            Votre abonnement est en brouillon. <br>
            Vous pouvez le prévisualiser, mais personne d'autre n'y aura accès.
          `,
          type: 'is-warning',
          focusOn: 'cancel',
          onConfirm: () => window.open(this.membershipURL),
        });
      }
    },
    handlePicture(file) {
      if (!file) {
        this.membership.picture = null;
        return;
      }

      if (file.size > this.$constants.MAX_IMAGE_SIZE) {
        this.$buefy.dialog.alert(this.$t('messages.file_larger_than', {
          size: '5 Mo',
        }));
        return;
      }

      const loader = this.$buefy.loading.open({ container: this.$refs.form[1] });
      toBase64(file)
        .then((base64) => (this.membership.picture = base64))
        .finally(() => loader.close());
    },
    handle(form, fk) {
      const membershipData = {};

      Object.keys(form)
        .forEach((key) => (membershipData[key] = this.membership[key]));

      membershipData.feature_options = { ...this.membership.feature_options };

      if (membershipData.picture && membershipData.picture.startsWith('http')) {
        delete membershipData.picture;
      }

      this.isLoading[fk] = true;
      this.$store.dispatch('memberships/update', { uuid: this.currentMembership.uuid, membershipData, isCurrent: true })
        .then(() => this.$showMessage.success())
        .finally(() => (this.isLoading[fk] = false));
    },
  },
};
</script>

<template>
  <AppFeatureWrapper>
    <template #title>
      Paramètres
    </template>
    <template #content>
      <p>
        Détaillez tous les aspects généraux de votre abonnement comme le titre, l'url
        ou encore l'image de mise en avant.
      </p>
    </template>

    <template #form>
      <form v-for="(form, fk) in $options.forms" :key="(form, fk)" ref="form" class="box"
        @submit.prevent="dataIsValid(isLoading[fk]) && handle(form, fk)">
        <div class="columns is-multiline">
          <div v-for="(field, key) in form"
            v-show="field.ifModelName == null || membership[field.ifModelName] == field.ifModelValue" :key="key"
            class="column" :class="field.column">
            <BaseField v-if="key == 'billing_address_enabled'" v-model="membership.feature_options.billing_address.enabled"
              :field="field" />
            <BaseField v-else-if="key == 'picture'" :field="field" :value="membership[key]" @input="handlePicture" />
            <BaseField v-else-if="key == 'slug'" v-model="membership[key]" :field="field">
              <template #addonLeft>
                <span class="button is-static">
                  {{ $store.getters['auth/domain'] }}/abonnements/
                </span>
              </template>
              <template #addonRight>
                <a class="button is-primary" :href="membershipURL" target="_blank" @click="onViewDraft">
                  <b-icon icon="link" />
                </a>
              </template>
              <template #help>
                C'est le lien d'accès à votre abonnement sur Teachizy.
                <a class="tdecoration-underline" :href="membershipURL" target="_blank" @click="onViewDraft">
                  Cliquez ici pour y accéder
                </a>
              </template>
            </BaseField>
            <BaseField v-else v-model="membership[key]" :field="field" />
          </div>
        </div>

        <b-field class="has-text-right">
          <b-button type="is-primary" native-type="submit" :loading="isLoading[fk]">
            Mettre à jour
          </b-button>
        </b-field>
      </form>
    </template>
  </AppFeatureWrapper>
</template>
